import { Gradient } from "whatamesh";

import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import initTestimonialSlider from "../js_modules/_testimonial-slider.mjs";

import expertiseShader from "../js_modules/_expertise-shader.mjs";
import homeEditorial from "../js_modules/_home-editorial.mjs";
import initServiceFourHero from "../js_modules/_service-four-hero.mjs";

gsap.registerPlugin(ScrollToPlugin);

import horizontalLoop from "../js_modules/_horizontal-loop.mjs";

const logos_line = gsap.utils.toArray(".service-four-hero__scrolling-project");

const goto_buttons = document.querySelectorAll(".go-to");

if (document.querySelector(".top-hosting__side-container-background")) {
  const gradient = new Gradient();
  gradient.initGradient("#gradient-canvas");
}

if (document.querySelector("#gradient-canvas-mobile")) {
  const gradient_mobile = new Gradient();
  gradient_mobile.initGradient("#gradient-canvas-mobile");
}

if (goto_buttons && goto_buttons.length > 0) {
  goto_buttons.forEach((button) => {
    const target = button.getAttribute("href");
    button.addEventListener("click", (e) => {
      e.preventDefault();
      gsap.to(window, { scrollTo: { y: target, offsetY: 50 }, duration: 1 });
    });
  });
}

horizontalLoop(logos_line, { speed: 0.8, repeat: -1 });

const go_to_test = document.querySelector(".go-to-test");

if (go_to_test) {
  go_to_test.addEventListener("click", (e) => {
    e.preventDefault();
    gsap.to(window, {
      duration: 1,
      scrollTo: { y: "#test-hebergement", offsetY: 100 },
    });
  });
}

const go_to_packages = document.querySelector(".go-to-packages");

if (go_to_packages) {
  go_to_packages.addEventListener("click", (e) => {
    e.preventDefault();
    gsap.to(window, {
      duration: 1,
      scrollTo: { y: "#forfaits", offsetY: -373 + 100 },
    });
  });
}

const form = document.querySelector(".test-hosting__form");
let form_button;
if (form) {
  form_button = form.querySelector(".test-hosting__form-button");

  form.addEventListener("submit", (e) => {
    e.preventDefault();
    form_button.classList.add("loading");

    let formData = new FormData(e.target);
    formData.append("action", "choco_get_hosting_test_results");
    formData.append("post_id", hosting_vars.post_id);
    /* Append d'autres données ici
    Ex: formData.append('variable', variable)
   */

    fetch(hosting_vars.ajax_url, {
      method: "POST",
      credentials: "same-origin",
      body: formData,
    })
      .then((response) => {
        let contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          return response.json().then((json) => {
            const bubble_span = document.querySelector(
              ".test-hosting__result-bubble > span.number",
            );
            const result_text = document.querySelector(
              ".test-hosting__result-text",
            );
            const result_text_outer = document.querySelector(
              ".test-hosting__result-text-outer",
            );
            const result_c2a = document.querySelector(
              ".test-hosting__result-c2a",
            );

            form_button.classList.remove("loading");

            gsap.set(result_text_outer, { display: "block" });
            gsap.set(result_c2a, { display: "none" });

            if (json.success) {
              bubble_span.textContent = json.data.ttfb;
              result_text.innerHTML = json.data.content;
            } else {
              bubble_span.textContent = "0";
              result_text.innerHTML = `<div class="test-hosting__result-error">${json.data.message}</div>`;
            }
          });
        }
      })
      .catch((err) => {
        console.log(err);
        form_button.classList.remove("loading");
      });
  });
}

initTestimonialSlider();

const faq_questions = document.querySelectorAll(".faq-questions__question");

if (faq_questions) {
  faq_questions.forEach((question) => {
    const trigger = question.querySelector(".faq-questions__question-top");
    const answer_outer = question.querySelector(
      ".faq-questions__question-answer-outer",
    );
    if (trigger) {
      trigger.addEventListener("click", () => {
        if (!trigger.classList.contains("open")) {
          trigger.classList.add("open");
          if (answer_outer) {
            gsap.to(answer_outer, { height: "auto", duration: 0.5 });
          }
        } else {
          trigger.classList.remove("open");
          if (answer_outer) {
            gsap.to(answer_outer, { height: 0, duration: 0.5 });
          }
        }
      });
    }
  });
}

expertiseShader();
homeEditorial();
initServiceFourHero();
